import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function InternalNotesTemplates() {
    return (
        <OnboardingBody statusText='New: Shared email inbox' title='Leverage internal notes'>
            <p>Tag a team member and add an internal note visible only to your organization.</p>
        </OnboardingBody>
    );
}
